// @ts-nocheck
import type {RhetoricalQuestion, SurveyHandler} from 'src/types/survey';

import * as React from 'react';
import {convertFromRaw, EditorState} from 'draft-js';
import ReactDOMServer from 'react-dom/server';

import linkify from 'src/utils/linkify';
import {SafeExternalLink} from 'src/components/lib/safe-external-link';

import Editor, {buildDecorator} from 'src/components/lib/markdown-editor/';

import css from './message.css';


type Props = {
  data: RhetoricalQuestion;
  handleNext: SurveyHandler;
  buttonColor: string;
  isLast: boolean;
  multiEntityEnabled: boolean;
};

class MessageSurveyModule extends React.Component<
  Props,
  {
    hovered: boolean;
  }
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hovered: false,
    };

    (this as any).handleOnMouseEnter = this.handleOnMouseEnter.bind(this);
    (this as any).handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
  }

  getNotificationHtml = () => {
    const rawHtml = this.props.data.rendered_html;

    return {
      __html: rawHtml,
    };
  };

  render() {
    const {data, handleNext, buttonColor, isLast, multiEntityEnabled} =
      this.props;

    let messageContent;
    if (data.rendered_html !== '') {
      messageContent = (
        <div
          className="RenderedRTE"
          dangerouslySetInnerHTML={this.getNotificationHtml()}
        />
      );
    } else if (data.rte_json) {
      const decorator = buildDecorator({
        dynamicLabels: [],
        linkTarget: '_blank',
        multiEntityEnabled,
      });
      const val = EditorState.createWithContent(
        convertFromRaw(data.rte_json),
        decorator,
      );
      messageContent = (
        <div>
          <Editor readOnly={true} value={val} linkTarget="_blank" />
        </div>
      );
    }

    return (
      <div className={css.messageBox}>
        {messageContent}
        {!isLast && (
          <button
            className={css.messageBoxButton}
            onClick={(evt: Event) => {
              evt.preventDefault();
              handleNext();
            }}
            style={{
              color: this.state.hovered ? 'white' : buttonColor,
              borderColor: buttonColor,
              backgroundColor: this.state.hovered ? buttonColor : undefined,
            }}
            onMouseEnter={this.handleOnMouseEnter}
            onMouseLeave={this.handleOnMouseLeave}
          >
            Next
          </button>
        )}
      </div>
    );
  }

  handleOnMouseEnter() {
    this.setState({
      hovered: true,
    });
  }

  handleOnMouseLeave() {
    this.setState({
      hovered: false,
    });
  }
}
export default MessageSurveyModule;

// Made with ♥️ by SpacedOut Labs
